import SvgIcon from "e100-react-components/lib/components/SvgIcon";
import { IPropTypes } from "e100-react-components/lib/components/Icon/index";
import { isEastTerritory } from "common/utils/checkTerritory";
import {
  AddBlue,
  Agent,
  AllFuel,
  Cluster,
  Currency,
  DieselFuel,
  DirectStart,
  E100Logo,
  Road,
  Roads,
  Parking,
  StationActive,
  Gas,
  Guard,
  Pos,
  Tire,
  Trace,
  Petrol,
  ActiveTune,
  EnvelopePicture,
  Car,
  Truck,
  BigAuto,
  ShowerOutlined,
  MobilePayment,
  Vector,
  Action,
  E1CardLogo,
  TruckWash,
  Auto,
  AutoOutlined,
  PointDisable,
  HistoryCar,
  StartLocation,
  EndLocation,
  LocationPoint,
  Map,
  Route,
  Next,
  Axles,
  Battery0Bar,
  Battery1Bar,
  Battery2Bar,
  Battery3Bar,
  Battery4Bar,
  Battery5Bar,
  Battery6Bar,
  BatteryFull,
  Sort,
  Setting,
  BoxTruck,
  Trailer,
  Scale,
  Signal,
  Mobile,
  Speed,
  Timer,
  TimerQuarter,
  TimerHalf,
  Star,
  Van,
  E100MainLogo,
  Layers,
  Check,
  Share,
  DoneAll,
  RoutePointForm,
  RoutePointTo,
  MyLocation,
  PlayCircle,
  LocationOnOutlined,
  DirectionsBusOutlined
} from "./Items";
export interface ISvgIconMap {
  [key: string]: typeof SvgIcon;
}

export const SVG_ICON_MAP = {
  activeTune: ActiveTune,
  addBlue: AddBlue,
  agent: Agent,
  allFuel: AllFuel,
  bigAuto: BigAuto,
  car: Car,
  cluster: Cluster,
  currency: Currency,
  dieselFuel: DieselFuel,
  directStart: DirectStart,
  gas: Gas,
  guard: Guard,
  parking: Parking,
  petrol: Petrol,
  pos: Pos,
  road: Road,
  roads: Roads,
  stationActive: StationActive,
  tire: Tire,
  trace: Trace,
  truck: Truck,
  envelopePicture: EnvelopePicture,
  showerOutlined: ShowerOutlined,
  vector: Vector,
  mobilePayment: MobilePayment,
  action: Action,
  e100Logo: E100Logo,
  truckWash: TruckWash,
  auto: Auto,
  autoOutlined: AutoOutlined,
  pointDisable: PointDisable,
  historyCar: HistoryCar,
  startLocation: StartLocation,
  endLocation: EndLocation,
  locationPoint: LocationPoint,
  map: Map,
  route: Route,
  next: Next,
  axles: Axles,
  battery0Bar: Battery0Bar,
  battery1Bar: Battery1Bar,
  battery2Bar: Battery2Bar,
  battery3Bar: Battery3Bar,
  battery4Bar: Battery4Bar,
  battery5Bar: Battery5Bar,
  battery6Bar: Battery6Bar,
  batteryFull: BatteryFull,
  sort: Sort,
  setting: Setting,
  boxTruck: BoxTruck,
  trailer: Trailer,
  scale: Scale,
  signal: Signal,
  mobile: Mobile,
  speed: Speed,
  timer: Timer,
  timerQuarter: TimerQuarter,
  timerHalf: TimerHalf,
  star: Star,
  van: Van,
  e100MainLogo: E100MainLogo,
  layers: Layers,
  check: Check,
  share: Share,
  doneAll: DoneAll,
  routePointForm: RoutePointForm,
  routePointTo: RoutePointTo,
  myLocation: MyLocation,
  playCircle: PlayCircle,
  locationOnOutlined: LocationOnOutlined,
  directionsBusOutlined: DirectionsBusOutlined,
  ...(isEastTerritory && { e1CardLogo: E1CardLogo }),
} as const;

export type Kind = IPropTypes["kind"] | keyof typeof SVG_ICON_MAP;

export const getSvgIcon = (kind?: string) =>
  // @ts-ignore
  SVG_ICON_MAP[kind || ""];
